import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'moment/locale/pt-br'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import cadastrarItinerario from '../../actions/itinerario/cadastrarItinerario'
import alterarItinerario from '../../actions/itinerario/alterarItinerario'
import { ativarItinerario, inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import { BotaoAtivarOuInativar } from './BotaoAtivarOuInativar';
import {
    renderFieldCheck, renderFieldNumeros,
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    tamanhoPorcentagem,
    validateHora,
    validateMinutos
} from '../../util/inputs';
import MotoristaItinerario from './MotoristaItinerario';
import UsuarioEmpresaBloqueioItinerario from './UsuarioEmpresaBloqueioItinerario';
import Select from 'react-select';
import { showAlertMsg, showSuccessMsg  } from '../../util/messagesUtil';
import BloqueioDescontoItinerario from './BloqueioDescontoItinerario';
import { tipoAjusteItinerario, tipoCategoria, tiposConfiguracoesPreco } from '../../util/constantsUtil';
import MapaVeiculoCategoriaPoltrona from './MapaVeiculoCategoriaPoltrona';
import selecionarVeiculoItinerario from '../../actions/itinerario/selecionarVeiculoItinerario';
import ModalConfiguracaoCategoriaPoltrona from './ModalConfiguracaoCategoriaPoltrona';
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';
import FieldsetBloquearVendedores from './FieldsetBloquearVendedores';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

const renderFieldHora = ({
    input,
    label,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <NumberFormat {...input} format="##:##"
                className={css}
                maxLength={max}
                style={{ borderColor: touched && error ? 'red' : '' }}
                readOnly={readOnly}
            />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);


export class ModalCadastrarItinerario extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.componentRef = React.createRef();
        this.limparFormulario = this.limparFormulario.bind(this);
        this.fecharModal = this.fecharModal.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.props.changeFieldValue('formularioCadastroItinerario', 'habilitadoSite',
            this.props.empresaSelecionada.habilitadoSite)
        this.state = {
            habilitaConfiguracaoCategoriaPoltrona: false,
            listaCategoriasPoltronas: [],
            tipoPrecoPrimeiroAndarPadrao: null,
            tipoPrecoSegundoAndarPadrao: null,
            andarSelecionado: this.props.itinerarioSelecionado.andar || 1
        }

    }

    onChangeDate = (date) => {
        this.props.changeFieldValue('formularioCadastroItinerario',
            'dataPartida', date);
    };

    handleExibirCamposAjusteValor(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'valorAjuste', '');
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoAjusteItinerario', '');
        }
        this.props.changeFieldValue('formularioCadastroItinerario',
            'exibirAjuste', evento.target.value);
    }

    montarParametroItinerario(values) {
        let tipoAjuste = null;
        let valorAjuste = null;
        let tipoPrecoSegundoAndar = null;
        let tipoConfiguracaoPreco = null;
        let horaPartidaRegra = null;
        let quantidadePoltronasRegra = null;

        if (values.exibirAjuste) {
            tipoAjuste = values.tipoAjusteItinerario.value;
            tipoConfiguracaoPreco = values.tipoConfiguracaoPreco.value;
            valorAjuste = values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
            if (tipoConfiguracaoPreco === 'DATA_PARTIDA') {
                horaPartidaRegra = values.horaPartidaRegra;
            }
            if (tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_CADA' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_ATE_NUMERO') {
                quantidadePoltronasRegra = values.quantidadePoltronasRegra;
            }
            if (tipoConfiguracaoPreco !== 'POR_USUARIO') {
                this.props.limparPricePorUsuario();
            }
        }
        if (!this.props.idItinerario && this.props.veiculo.value.seDoisAndares) {
            tipoPrecoSegundoAndar = this.props.exibeTipoCategoriaUnica ? values.tipoPrecoSegundoAndar.value : null
        }
        return {
            id: values.idItinerario,
            descontoMaximo: values.descontoMaximo ? values.descontoMaximo.replace('R$', '') : '0.00',
            dataPartida: values.dataPartida,
            horaSaida: values.horaSaida,
            habilitadoSite: values.habilitadoSite ? values.habilitadoSite : false,
            idVeiculo: values.veiculo.value.id,
            idsUsuariosEmpresaMotorista: this.props.motoristasSelecionados ? this.props.motoristasSelecionados.map(it => it.value) : null,
            idsUsuariosEmpresaBloqueio: this.props.usuarioEmpresaBloqueioSelecionados ? this.props.usuarioEmpresaBloqueioSelecionados.map(it => it.value) : null,
            idEmpresa: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            trechosBloqueados: this.props.trechosSelecionados.map(it => (
                { idTrechoOrigem: it.origem.value, idTrechoDestino: it.destino.value }
            )),
            cidadeBloqueadas: this.props.cidadesSelecionadas.map(it => (
                { idCidade: it.value }
            )),
            trechosBloqueadosDesconto: this.props.trechosBloqueioDescontoSelecionados.map(it => (
                { idTrechoOrigem: it.origem.value, idTrechoDestino: it.destino.value }
            )),
            valorAjuste,
            tipoAjuste,
            tipoPrecoPrimeiroAndar: this.props.exibeTipoCategoriaUnica ? values.tipoPrecoPrimeiroAndar.value : null,
            tipoPrecoSegundoAndar,
            tipoConfiguracaoPreco,
            horaPartidaRegra,
            quantidadePoltronasRegra,
            idPrestador: values.prestador ? values.prestador.value : null,
            tipoCategoria: this.props.exibeTipoCategoriaUnica ? tipoCategoria.unica.valor : tipoCategoria.mista.valor,
            tipoPrecoPrimeiroAndarPadrao: this.state.tipoPrecoPrimeiroAndarPadrao,
            tipoPrecoSegundoAndarPadrao: this.state.tipoPrecoSegundoAndarPadrao,
            listaCategoriasPoltronas: !this.props.exibeTipoCategoriaUnica ? this.state.listaCategoriasPoltronas.map(it => {
                return {
                    numeroAssento: it.assento.numero,
                    tipoPreco: it.tipoPreco,
                    andar: it.andar
                }
            }) : null,
            pricePorUsuarioEmpresa: this.props.vendedoresSelecionados.map(it => {
                return {
                    tipoAjuste: it.tipoAjusteItinerario.value,
                    valorAjuste: it.valorAjuste,
                    tipoConifguracaoPreco: it.tipoConfiguracaoPreco ? it.tipoConfiguracaoPreco.value : 'POR_USUARIO',
                    usuarioId: it.id,
                }
            })

        }
    }

    fecharModal() {
        $('#modalCadastrarItinerario')
            .modal('hide');
        $('#modalCadastrarItinerario')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    handleChecked() {
        this.props.handleCheckedTipoCategoriaUnica();
    }

    exibirCheckboxTipoCategoria() {
        return (
            <div className="col-12 col-sm-2 col-md-2 container-tipo-categoria-unica">
                <label htmlFor='exibeTipoCategoriaUnica'>Tipo Categoria</label>
                <div className='form-group form-check'>
                    <input type="radio" name='exibeTipoCategoriaUnica'
                        className='form-check-input' onChange={this.handleChecked} value={this.props.exibeTipoCategoriaUnica} checked={this.props.exibeTipoCategoriaUnica} />
                    <label className='form-check-label'>{tipoCategoria.unica.descricao}</label>
                </div>
                <div className='form-group form-check'>
                    <input type="radio" name='exibeTipoCategoriaUnica'
                        className='form-check-input' onChange={this.handleChecked} value={!this.props.exibeTipoCategoriaUnica} checked={!this.props.exibeTipoCategoriaUnica} />
                    <label className='form-check-label'>{tipoCategoria.mista.descricao}</label>
                </div>
            </div>
        )
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values);        
        if (this.props.idItinerario) {
            this.props.alterarItinerario(parametros).then(() => {
                showSuccessMsg('Itinerário alterado com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios()
            })
        } else {
            this.props.cadastrarItinerario(parametros).then(() => {
                showSuccessMsg('Itinerário cadastrado com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios()
            })
        }
    }


    limparFormulario() {
        this.props.reset('formularioCadastroItinerario');
        this.props.limparMotoristasSelecionados();
        this.props.limparUsuarioEmpresaBloqueioSelecionados();
        this.props.limparTrechosSelecionados();
        this.props.limparCidadesSelecionadas();
        this.props.limparPricePorUsuario();
        this.props.handleCheckedTipoCategoriaUnica(true);
        this.verificarAndarSelecionado(1);
        this.props.limparVeiculoItinerarioSelecionado();
        this.setState({ habilitaConfiguracaoCategoriaPoltrona: true });
        this.props.changeFieldValue('formularioCadastroItinerario', 'habilitadoSite',
            this.props.empresaSelecionada.habilitadoSite)
    }


    exibirComboTipoPreco(name, label) {
        return <div className="col-12 col-sm-4 col-md-4">
            <Field name={name}
                options={this.props.tiposPreco.map(elemento => ({
                    descricao: elemento.descricaoTipoPreco,
                    nome: elemento.tipoPreco
                }))}
                component={renderFieldSelect}
                label={label}
                placeholder='Selecione a categoria'
                validate={requiredSelect} />
        </div>
    }


    exibirCalendario(event) {
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        selected={this.props.dataPartida}
                        locale="pt-BR"
                        onChange={date => this.onChangeDate(date)}
                        placeholder={`${this.props.dataPartida}`}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }


    exibirAjuste() {
        if (this.props.exibirAjuste) {
            return <React.Fragment>
                <div className="col-12 col-sm-3 col-md-3">
                    <Field name='tipoAjusteItinerario'
                        options={tipoAjusteItinerario.map(elemento => ({
                            descricao: elemento.label,
                            nome: elemento.value
                        }))}
                        component={renderFieldSelect}
                        label="Descontos/Acréscimos"
                        placeholder='Selecione um tipo' validate={requiredSelect} />
                </div>
                <div className="col-12 col-sm-2 col-md-2">
                    <Field name='valorAjuste' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="Desconto/Acréscimo(%):" />
                </div>
                <div className="col-12 col-sm-5 col-md-5">
                    <Field name='tipoConfiguracaoPreco'
                        options={tiposConfiguracoesPreco.map(elemento => ({
                            descricao: elemento.label,
                            nome: elemento.value
                        }))}
                        component={renderFieldSelect}
                        label="Regra de desconto/acréscimo"
                        validate={requiredSelect} />
                </div>
                {this.props.tipoConfiguracaoPreco && this.props.tipoConfiguracaoPreco.value === 'DATA_PARTIDA' ?
                    <React.Fragment>
                        <div className="col-12 col-sm-2 col-md-2">
                            <Field name="horaPartidaRegra"
                                css='form-control'
                                component={renderFieldHora}
                                label="Hora"
                                validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]} />
                        </div>
                    </React.Fragment> : ''}

                {this.props.tipoConfiguracaoPreco && (this.props.tipoConfiguracaoPreco.value === 'POLTRONAS_VENDIDAS_A_CADA' ||
                    this.props.tipoConfiguracaoPreco.value === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
                    this.props.tipoConfiguracaoPreco.value === 'POLTRONAS_VENDIDAS_ATE_NUMERO') ?
                    <React.Fragment>
                        <div className="col-12 col-sm-2 col-md-2 mt-2">
                            <label>Número de poltronas</label>
                            <Field name="quantidadePoltronasRegra" type="text" component={renderFieldNumeros}
                                valor={this.props.quantidadePoltronasRegra}
                                formatacao='##'
                                css="form-control" />
                        </div>
                    </React.Fragment> : ''}
                    {this.props.tipoConfiguracaoPreco && this.props.tipoConfiguracaoPreco.value === 'POR_USUARIO' ? <>
                        <div className="col-12 col-sm-5 col-md-5">                           
                            <Field name='vendedores'
                                options={this.props.usuariosVendedores.map(elemento => ({
                                    descricao: elemento.valor,
                                    nome: elemento.chave
                                }))}
                                component={renderFieldSelect}
                                label="Adicionar Usuarios Vendedores"
                                placeholder='Selecione um usuário'                                 
                            />
                        </div>
                        <div className="col-12 col-sm-3 col-md-2" style={{marginTop: '2.2rem'}}>
                            <button
                                type="submit" className="btn btn-sm btn-laranja"
                                onClick={(e) => this.adicionarPricePorUsuario(e)}
                                >Incluir
                            </button>
                        </div>
                        <div className="col-12 col-sm-12 col-md-10 mt-2">
                            <div className="lista-table">
                                {this.exibirUsuariosVendedoresSelecionados()}
                            </div>
                        </div>
                    </>:''}

            </React.Fragment>
        }
    }

    handleSelecionarMotorista(evento) {
        this.props.selecionarMotorista(evento);
    }

    handleSelecionarUsuarioBloqueio(evento) {
        this.props.selecionarVendedorParaBloquear(evento);
    }

    handleSelecionarVeiculo(evento) {
        this.verificarAndarSelecionado(1);
        this.props.selecionarVeiculoItinerario(evento);
    }

    exibirUsuarioEmpresaBloequeioItinerario() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr colSpan='2' className='text-center'>
                    <th>Usuarios Selecionados</th>
                </tr>
            </thead>
            <tbody>
                {!this.props.usuarioEmpresaBloqueioSelecionados || this.props.usuarioEmpresaBloqueioSelecionados.length === 0 ?
                    <tr colSpan='2' className="alert alert-warning text-center mt-4" role="alert">
                        <td>Nenhum usuário foi selecionado.</td>
                    </tr>
                    :
                    this.props.usuarioEmpresaBloqueioSelecionados
                        .map((usuario, index) => <UsuarioEmpresaBloqueioItinerario
                            removerUsuarioEmpresaBloqueio = {this.props.removerUsuarioEmpresaBloqueio}
                            key={index} usuario={usuario}
                            indice={index} />)}
            </tbody>
        </table>
    }

    exibirMotoristaItinerario() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr colSpan='2' className='text-center'>
                    <th>Motoristas Selecionados</th>
                </tr>
            </thead>
            <tbody>
                {!this.props.motoristasSelecionados || this.props.motoristasSelecionados.length === 0 ?
                    <tr colSpan='2' className="alert alert-warning text-center mt-4" role="alert">
                        <td>Nenhum motorista foi selecionado.</td>
                    </tr>
                    :
                    this.props.motoristasSelecionados
                        .map((motorista, index) => <MotoristaItinerario
                            removerMotorista={this.props.removerMotorista}
                            key={index} motorista={motorista}
                            indice={index} />)}
            </tbody>
        </table>
    }

    exibirCidadesSelecionadas() {
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr className='text-center'>
                        <th colSpan='3'>Cidades Bloqueadas</th>
                    </tr>
                    <tr>
                        <th>Cidade</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {!this.props.cidadesSelecionadas || this.props.cidadesSelecionadas.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='3'>Nenhuma cidade foi
                                bloqueada.
                            </td>
                        </tr>
                        :
                        this.props.cidadesSelecionadas
                            .map((cidade, i) => <tr key={i}>
                                <td>
                                    {cidade.label}
                                </td>
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    <div
                                        onClick={() => this.props.removerCidadeSelecionada(cidade.value)}>Remover
                                    </div>
                                </td>
                            </tr>)}
                </tbody>
            </table>
        )

    }

    exibirTrechosSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr className='text-center'>
                    <th colSpan='3'>Trechos Bloqueados</th>
                </tr>
                <tr>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {!this.props.trechosSelecionados || this.props.trechosSelecionados.length === 0 ?
                    <tr className="alert alert-warning text-center mt-4" role="alert">
                        <td colSpan='3'>Nenhum trecho foi
                            bloqueado.
                        </td>
                    </tr>
                    :
                    this.props.trechosSelecionados
                        .map((trecho) => <tr key={trecho.id}>
                            <td>
                                {trecho.origem.label}
                            </td>
                            <td>
                                {trecho.destino.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div
                                    onClick={() => this.props.removerTrechoSelecionado(trecho.origem.value, trecho.destino.value)}>Remover
                                </div>
                            </td>
                        </tr>)}
            </tbody>
        </table>
    }

    exibirUsuariosVendedoresSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr className='text-center'>
                    <th colSpan='5'>Vendedores</th>
                </tr>
                <tr>
                    <th>ID</th>
                    <th>Desconto/Acréscimo</th>
                    <th>Valor(%)</th>
                    <th>Descricao</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {!this.props.vendedoresSelecionados || this.props.vendedoresSelecionados.length === 0 ?
                    <tr className="alert alert-warning text-center mt-4" role="alert">
                        <td colSpan='5'>Nenhum vendedor foi
                            cadastrado.
                        </td>
                    </tr>
                    :
                    this.props.vendedoresSelecionados
                        .map((vendedor) => <tr key={vendedor.id}>
                            <td>
                                {vendedor.id}
                            </td>                            
                            <td>
                                {vendedor.tipoAjusteItinerario.label}
                            </td>
                            <td>
                                {vendedor.valorAjuste}
                            </td>
                            <td>
                                {vendedor.vendedor.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div
                                    onClick={() => this.props.removerUsuarioVendedor(vendedor.id)}
                                    >Remover
                                </div>
                            </td>
                        </tr>)}
            </tbody>
        </table>        
    }

    adicionarCidade(event) {
        event.preventDefault();
        this.props.adicionarCidades(this.props.cidade);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'cidade', null);
    }

    adicionarTrechos(event) {
        event.preventDefault();
        this.props.adicionarTrechos(this.props.trechoOrigem, this.props.trechoDestino);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'trechoOrigem', null);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'trechoDestino', null);
    }

    adicionarPricePorUsuario(event) {
        event.preventDefault();        
        if (!this.props.valorAjuste) {
            showAlertMsg('Informe o valor.');
            return;
        }
        if (!this.props.tipoAjusteItinerario) {
            showAlertMsg('Informe o desconto/acréscimo.');
            return;
        }
        if (!this.props.vendedores) {
            showAlertMsg('Informe o usuário.');
            return;
        }
        const obj = {id: this.props.vendedores.value, vendedor: this.props.vendedores, valorAjuste: this.props.valorAjuste, 
            tipoAjusteItinerario: this.props.tipoAjusteItinerario, tipoConfiguracaoPreco: this.props.tipoConfiguracaoPreco };
        this.props.adicionarPricePorUsuario(obj);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'vendedores', null);        
    }

    recuperarTrechos() {
        if (this.props.rotas && this.props.rotaSelecionada) {
            return this.props.trechos.sort((n1, n2) => {
                if (n1.ordem > n2.ordem) {
                    return 1;
                }

                if (n1.ordem < n2.ordem) {
                    return -1;
                }

                return 0;
            });
        }
        return []
    }

    preencherListaCategoriasPoltronas(lista) {
        this.setState({ listaCategoriasPoltronas: lista })
    }

    preencherTipoPrechoPrimeiroAndarPadrao(tipo) {
        this.setState({ tipoPrecoPrimeiroAndarPadrao: tipo })
    }

    preencherTipoPrechoSegundoAndarPadrao(tipo) {
        this.setState({ tipoPrecoSegundoAndarPadrao: tipo })
    }

    verificarAndarSelecionado(andarSelecionado) {
        this.setState({ andarSelecionado });
    }

    desabilitarBotaoSalvar() {
        if (this.props.exibeTipoCategoriaUnica) return false;

        if (!this.props.idItinerario && !this.state.habilitaConfiguracaoCategoriaPoltrona) {
            return true;
        }

        if (!this.props.exibeTipoCategoriaUnica) {
            if (!this.idItinerario && this.props.veiculoItinerarioSelecionado.value.seDoisAndares) {
                return this.state.tipoPrecoPrimeiroAndarPadrao == null || this.state.tipoPrecoSegundoAndarPadrao == null;
            } else if (this.state.andarSelecionado == 1) {
                return this.state.tipoPrecoPrimeiroAndarPadrao == null;
            } else if (this.state.andarSelecionado == 2) {
                return this.state.tipoPrecoSegundoAndarPadrao == null;
            }
        }

        return false;
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;

        const trechos = this.recuperarTrechos();
        return (
            <div className="modal fade show" id='modalCadastrarItinerario' role='dialog'
                aria-labelledby='modalCadastrarItinerario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{this.props.idItinerario ? 'Editar Itinerário' : 'Novo Itinerário'}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Informações básicas</legend>
                                    <div className="col-12 col-sm-2 col-md-2 mt-2">
                                        <label>Data de partida</label>
                                        <Field name="dataPartida" type="texto"
                                            component={this.exibirCalendario.bind(this)}
                                            css="form-control col-md-12" readOnly={false} />
                                    </div>
                                    <div className="col-6 col-sm-2 col-md-2">
                                        <Field name="horaSaida" type="texto" component={renderFieldHora}
                                            label='Hora de partida'
                                            css="form-control col-md-12" readOnly={false}
                                            validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name='veiculo'
                                            options={this.props.veiculos.map(elemento => ({
                                                descricao: elemento.descricao,
                                                nome: elemento
                                            }))}
                                            component={renderFieldSelect}
                                            label="Veículo"
                                            placeholder='Selecione um veículo' validate={requiredSelect}
                                            disabled={this.props.idItinerario}
                                            onChange={(e) => this.handleSelecionarVeiculo(e)}
                                        />
                                    </div>
                                    {this.props.empresaSelecionada.habilitadoSite ?
                                        <div className="col-12 col-sm-2 col-md-2 mt-3">
                                            <label className='mt-2' />
                                            <Field name='habilitadoSite' type="checkbox" component={renderFieldCheck}
                                                label="Vender no site?"
                                                css="form-check-input" />
                                        </div> :
                                        <div className="col-12 col-sm-2 col-md-2 mt-3">
                                            <label className='mt-2' />
                                        </div>
                                    }
                                    {this.exibirCheckboxTipoCategoria()}

                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name='prestador'
                                            options={this.props.prestadoresSimples.map(elemento => ({
                                                descricao: elemento.valor,
                                                nome: elemento.chave
                                            }))}
                                            component={renderFieldSelect}
                                            label="Prestador"
                                            placeholder='Selecione um prestador' />
                                    </div>
                                </fieldset>

                                {this.props.exibeTipoCategoriaUnica && <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Configuração categoria</legend>
                                    <div className="col-12 col-sm-12 col-md-12">
                                        {this.exibirComboTipoPreco('tipoPrecoPrimeiroAndar', !this.props.idItinerario && this.props.veiculo && this.props.veiculo.value.seDoisAndares ? 'Categoria 1° andar' : 'Categoria')}
                                        {!this.props.idItinerario && this.props.veiculo && this.props.veiculo.value.seDoisAndares ? this.exibirComboTipoPreco('tipoPrecoSegundoAndar', 'Categoria 2° andar') : ''}
                                    </div>
                                </fieldset>}

                                {!this.props.exibeTipoCategoriaUnica && this.props.veiculo &&
                                    <fieldset className="scheduler-border">
                                        <legend className="scheduler-border">Configurações de categorias para poltronas</legend>
                                        <div className="col-12 col-sm-12 col-md-12">
                                            {!this.props.idItinerario && !this.state.habilitaConfiguracaoCategoriaPoltrona ? <button className="btn btn-laranja" onClick={(e) => { e.preventDefault(); this.setState({ habilitaConfiguracaoCategoriaPoltrona: true }) }}>Editar</button> : ''}
                                            {this.state.habilitaConfiguracaoCategoriaPoltrona || this.props.idItinerario ? <ModalConfiguracaoCategoriaPoltrona
                                                idItinerario={this.props.idItinerario}
                                                exibeTipoCategoriaUnica={this.props.exibeTipoCategoriaUnica}
                                                preencherListaCategoriasPoltronas={this.preencherListaCategoriasPoltronas.bind(this)}
                                                preencherTipoPrechoPrimeiroAndarPadrao={this.preencherTipoPrechoPrimeiroAndarPadrao.bind(this)}
                                                preencherTipoPrechoSegundoAndarPadrao={this.preencherTipoPrechoSegundoAndarPadrao.bind(this)}
                                                andarSelecionado={this.state.andarSelecionado}
                                                verificarAndarSelecionado={this.verificarAndarSelecionado.bind(this)} />
                                                : <MapaVeiculoCategoriaPoltrona idItinerario={this.props.idItinerario} andarSelecionado={this.state.andarSelecionado} verificarAndarSelecionado={this.verificarAndarSelecionado.bind(this)} />}
                                        </div>
                                    </fieldset>}

                                {!this.props.exibeTipoCategoriaUnica && !this.props.veiculo && <div>
                                    <p style={{ color: 'red' }}>Para exibir o mapa selecione um veículo.</p>
                                </div>}

                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Configuração de preço</legend>
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <Field type="checkbox" name='exibirAjuste' component={renderFieldCheck}
                                            label="Incluir desconto ou acréscimo na passagem"
                                            css="form-check-input" readOnly={false}
                                            onChange={e => this.handleExibirCamposAjusteValor(e)} />
                                    </div>
                                    {this.exibirAjuste()}
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Desconto máximo do itinerário </legend>
                                    <div className="col-12 col-sm-2 col-md-2">
                                        <Field name='descontoMaximo' validate={[tamanhoPorcentagem]}
                                            component={renderFieldNumerosPorcentagem}
                                            css="form-control" label="Desconto máximo(%):" />
                                    </div>
                                </fieldset>
                                {this.props.exibirAjuste ?
                                    <BloqueioDescontoItinerario
                                        trechoDestinoBloqueioDesconto={this.props.trechoDestinoBloqueioDesconto}
                                        changeFieldValue={this.props.changeFieldValue}
                                        trechoOrigemBloqueioDesconto={this.props.trechoOrigemBloqueioDesconto}
                                        trechosBloqueioDescontoSelecionados={this.props.trechosBloqueioDescontoSelecionados}
                                        adicionarTrechosBloqueioDesconto={this.props.adicionarTrechosBloqueioDesconto}
                                        removerTrechoBloqueioDescontoSelecionado={this.props.removerTrechoBloqueioDescontoSelecionado}
                                        rotaSelecionada={this.props.rotaSelecionada}
                                        rotas={this.props.rotas}
                                        trechos={trechos}
                                    /> : ''}
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Bloqueio de venda em trechos</legend>
                                    <div className="col-12 col-sm-9 col-md-5">
                                        <Field name='trechoOrigem'
                                            options={trechos.map(elemento => ({
                                                descricao: elemento.cidadeDestino.nome,
                                                nome: elemento.id
                                            }))}
                                            component={renderFieldSelect}
                                            placeholder='Selecione o trecho de origem' />
                                    </div>
                                    <div className="col-12 col-sm-9 col-md-5">
                                        <Field name='trechoDestino'
                                            options={trechos.map(elemento => ({
                                                descricao: elemento.cidadeDestino.nome,
                                                nome: elemento.id
                                            }))}
                                            component={renderFieldSelect}
                                            placeholder='Selecione o trecho de destino' />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-1">
                                        <button disabled={!this.props.trechoOrigem || !this.props.trechoDestino}
                                            type="submit" className="btn btn-sm btn-laranja"
                                            onClick={(e) => this.adicionarTrechos(e)}>Incluir
                                        </button>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-10 mt-2">
                                        <div className="lista-table">
                                            {this.exibirTrechosSelecionados()}
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Bloqueio de venda por cidades</legend>
                                    <div className="col-12 col-sm-9 col-md-5">
                                        <Field name="cidade"
                                            options={trechos.map(elemento => ({
                                                descricao: elemento.cidadeDestino.nome,
                                                nome: elemento.cidadeDestino.id
                                            }))}
                                            component={renderFieldSelect}
                                            placeholder='Selecione a cidade' />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-1">
                                        <button disabled={!this.props.cidade}
                                            type="submit" className="btn btn-sm btn-laranja"
                                            onClick={(e) => this.adicionarCidade(e)}>Incluir
                                        </button>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-10 mt-2">
                                        <div className="lista-table">
                                            {this.exibirCidadesSelecionadas()}
                                        </div>
                                    </div>
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Vinculo de motoristas</legend>
                                    <div className="col-12 col-sm-12 col-md-9">
                                        <div>
                                            <Select
                                                ref={this.componentRef}
                                                placeholder='Adicionar motorista'
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        height: 35,
                                                        minHeight: 32,
                                                        fontSize: 16,
                                                        width: '100%',
                                                        borderColor: '#e4e7ea',
                                                        cursor: 'pointer'
                                                    })
                                                }}
                                                value={null}
                                                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                                options={this.props.motoristas.filter(it => !this.props.motoristasSelecionados.map(it => it.value).includes(it.usuarioEmpresaId))
                                                    .map(elemento => ({
                                                        label: elemento.nome,
                                                        value: elemento.usuarioEmpresaId
                                                    }))}
                                                onChange={e => this.handleSelecionarMotorista(e)} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-9 mt-2">
                                        <div className="lista-table">
                                            {this.exibirMotoristaItinerario()}
                                        </div>
                                    </div>
                                </fieldset>
                                <FieldsetBloquearVendedores
                                    usuariosDisponiveis={this.props.usuariosVendedores}
                                    vendedoresSelecionados={this.props.usuarioEmpresaBloqueioSelecionados}
                                    onAdicionar={this.props.selecionarVendedorParaBloquear}
                                    onRemover={this.props.removerUsuarioEmpresaBloqueio}
                                />
                                
                                <div className="modal-footer">
                                    {this.props.idItinerario && <BotaoAtivarOuInativar
                                        idItinerario={this.props.idItinerario}
                                        idEmpresa={this.props.itinerarioSelecionado.idEmpresa}
                                        ativo={this.props.itinerarioSelecionado.ativo}
                                        ativarItinerario={this.props.ativarItinerario}
                                        inativarItinerario={this.props.inativarItinerario}
                                        buscarItinerarios={this.props.buscarItinerarios}
                                        fecharModal={this.fecharModal} />}

                                    <button type="submit" disabled={invalid || submitting || pristine || this.desabilitarBotaoSalvar()}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            tipoConfiguracaoPreco: { label: 'Normal', value: 'NORMAL' },
            prestador: { label: 'Frota própria', value: '' }
        },
        exibirAjuste: formValueSelector('formularioCadastroItinerario')(state, 'exibirAjuste'),
        descontoMaximo: formValueSelector('formularioCadastroItinerarioPorPeriodo')(state, 'descontoMaximo'),
        tipoConfiguracaoPreco: formValueSelector('formularioCadastroItinerario')(state, 'tipoConfiguracaoPreco'),
        idItinerario: formValueSelector('formularioCadastroItinerario')(state, 'idItinerario'),
        dataPartida: formValueSelector('formularioCadastroItinerario')(state, 'dataPartida'),
        horaPartidaRegra: formValueSelector('formularioCadastroItinerario')(state, 'horaPartidaRegra'),
        quantidadePoltronasRegra: formValueSelector('formularioCadastroItinerario')(state, 'quantidadePoltronasRegra'),
        trechoOrigem: formValueSelector('formularioCadastroItinerario')(state, 'trechoOrigem'),
        trechoDestino: formValueSelector('formularioCadastroItinerario')(state, 'trechoDestino'),
        cidade: formValueSelector('formularioCadastroItinerario')(state, 'cidade'),
        trechoOrigemBloqueioDesconto: formValueSelector('formularioCadastroItinerario')(state, 'trechoOrigemBloqueioDesconto'),
        trechoDestinoBloqueioDesconto: formValueSelector('formularioCadastroItinerario')(state, 'trechoDestinoBloqueioDesconto'),
        veiculo: formValueSelector('formularioCadastroItinerario')(state, 'veiculo'),
        assentosDisponiveis: formValueSelector('formularioCadastroItinerario')(state, 'assentosDisponiveis'),
        prestador: formValueSelector('formularioCadastroItinerario')(state, 'prestador'),
        vendedores: formValueSelector('formularioCadastroItinerario')(state, 'vendedores'),
        valorAjuste: formValueSelector('formularioCadastroItinerario')(state, 'valorAjuste'),
        tipoAjusteItinerario: formValueSelector('formularioCadastroItinerario')(state, 'tipoAjusteItinerario'), 
        empresaSelecionada: state.empresaSelecionada,
        tiposPreco: state.tiposPreco,
        veiculos: state.veiculos.veiculos,
        itinerarioSelecionado: state.itinerarioSelecionado,
        paginaAtual: state.paginaAtualItinerario,
        registrosPorPagina: state.registrosPorPaginaItinerario,
        rotaSelecionada: state.rotaSelecionada,
        motoristas: state.motoristas,
        rotas: state.rotas.rotas,
        prestadoresSimples: state.prestadores.prestadoresSimples,
        trechos: state.trechos,
        veiculoItinerarioSelecionado: state.veiculoItinerarioSelecionado,
        usuariosVendedores: state.usuariosVendedores
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarItinerario,
        alterarItinerario,
        ativarItinerario,
        inativarItinerario,
        selecionarVeiculoItinerario,
        limparVeiculoItinerarioSelecionado
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroItinerario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalCadastrarItinerario));
